import { invoke } from "@tauri-apps/api/core";
import { WebviewWindow } from "@tauri-apps/api/webviewWindow";
export const initialMouseSpeed = window.__TAURI__ ? await invoke("get_cursor_speed") : 5;
let currentMouseSpeed = initialMouseSpeed;
export function setMouseSpeed(_speed) {
    const speed = Math.min(20, Math.max(1, _speed));
    if (window.__TAURI__) {
        void invoke("set_cursor_speed", { speed });
    }
    currentMouseSpeed = speed;
}
export function resetMouseSpeed() {
    if (window.__TAURI__) {
        void invoke("set_cursor_speed", { speed: initialMouseSpeed });
    }
}
if (window.__TAURI__) {
    const appWindow = WebviewWindow.getCurrent();
    void appWindow.onFocusChanged(({ payload: focused }) => {
        if (focused) {
            setMouseSpeed(currentMouseSpeed);
        }
        else {
            resetMouseSpeed();
        }
    });
}
//# sourceMappingURL=mouseSpeed.js.map